import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { notBlankValidation } from '../../../utils/validations';
import Input from '../../shared/input/Input';

const ModelForm = ({ onSubmit, initModel = {}, readOnly, loading }) => {
  const methods = useForm({ defaultValues: initModel });
  return (
    <FormProvider {...methods}>
      <form id="model-form" noValidate className="modal-form" onSubmit={methods.handleSubmit((data) => onSubmit(data))}>
        <Input
          label="Назва моделі"
          type="input"
          name="name"
          autoFocus="true"
          disabled={readOnly || loading}
          placeholder={'Введіть назву моделі'}
          validation={notBlankValidation}
        />
      </form>
    </FormProvider>
  );
};

export default ModelForm;
